// Single source of truth for all domain-level enumerations in Hirafi.
// Import from here instead of defining inline in components or hooks.

export const ANNONCE_CATEGORIES = [
  { value: "plumbing",      label: "Plomberie",               label_ar: "السباكة" },
  { value: "electricity",   label: "Électricité",             label_ar: "الكهرباء" },
  { value: "locksmith",     label: "Serrurerie",              label_ar: "القفالة" },
  { value: "carpentry",     label: "Menuiserie",              label_ar: "النجارة" },
  { value: "plaquiste",     label: "Placoplâtre",             label_ar: "الجبسبورد" },
  { value: "pvc_aluminium", label: "PVC / Aluminium",         label_ar: "PVC / ألومنيوم" },
  { value: "painting",      label: "Peinture et décoration",  label_ar: "الطلاء والديكور" },
  { value: "masonry",       label: "Maçonnerie",              label_ar: "البناء" },
  { value: "tiling",        label: "Carrelage",               label_ar: "الإفريز" },
  { value: "hvac",          label: "Climatisation",           label_ar: "التكييف" },
  { value: "kitchen",       label: "Cuisiniste",               label_ar: "مصمم المطابخ" },
  { value: "handyman",      label: "Artisan polyvalent",      label_ar: "حرفي متعدد التخصصات" },
] as const;

export type AnnonceCategoryValue = (typeof ANNONCE_CATEGORIES)[number]["value"];

export const ANNONCE_CATEGORY_LABEL: Record<string, string> = Object.fromEntries(
  ANNONCE_CATEGORIES.map(({ value, label }) => [value, label])
);

// Note: artisan specialites use French strings as DB values (not slugs).
// The first entry ("tous") is a UI-only filter sentinel — never persisted.
export const ARTISAN_SPECIALITES = [
  { value: "tous",                          label: "Toutes spécialités",              label_ar: "كل التخصصات" },
  { value: "Plomberie",                     label: "Plomberie",                       label_ar: "السباكة" },
  { value: "Électricité",                   label: "Électricité",                     label_ar: "الكهرباء" },
  { value: "Serrurerie",                    label: "Serrurerie",                      label_ar: "القفالة" },
  { value: "Menuiserie",                    label: "Menuiserie",                      label_ar: "النجارة" },
  { value: "Plaquiste",                     label: "Placoplâtre",                     label_ar: "الجبسبورد" },
  { value: "PVC / Aluminium",               label: "PVC / Aluminium",                 label_ar: "PVC / ألومنيوم" },
  { value: "Peinture et décoration",        label: "Peinture et décoration",          label_ar: "الطلاء والديكور" },
  { value: "Maçonnerie",                    label: "Maçonnerie",                      label_ar: "البناء" },
  { value: "Carrelage",                     label: "Carrelage",                       label_ar: "الإفريز" },
  { value: "Climatisation",                 label: "Climatisation",                   label_ar: "التكييف" },
  { value: "Cuisiniste",                    label: "Cuisiniste",                      label_ar: "مصمم المطابخ" },
  { value: "Artisan polyvalent",            label: "Artisan polyvalent",              label_ar: "حرفي متعدد التخصصات" },
  { value: "Entreprise tout corps d'état",  label: "Entreprise tout corps d'état",    label_ar: "شركة متعددة التخصصات" },
] as const;

export type ArtisanSpecialiteValue = (typeof ARTISAN_SPECIALITES)[number]["value"];

export const ANNONCE_URGENCY = [
  { value: "asap",     label: "Dès que possible", label_ar: "في أقرب وقت" },
  { value: "thisWeek", label: "Cette semaine",     label_ar: "هذا الأسبوع" },
  { value: "flexible", label: "Flexible",          label_ar: "مرن" },
] as const;

export type AnnonceUrgencyValue = (typeof ANNONCE_URGENCY)[number]["value"];

export const ANNONCE_URGENCY_LABEL: Record<string, string> = Object.fromEntries(
  ANNONCE_URGENCY.map(({ value, label }) => [value, label])
);

export const ARTISAN_AVAILABILITY = [
  { value: "disponible", label: "Disponible", label_ar: "متاح" },
  { value: "occupe",     label: "Occupé",     label_ar: "مشغول" },
  { value: "conge",      label: "En congé",   label_ar: "في إجازة" },
] as const;

export type ArtisanAvailabilityValue = (typeof ARTISAN_AVAILABILITY)[number]["value"];

// Upload constraints
export const MESSAGE_IMAGE_ACCEPTED = ["image/jpeg", "image/png", "image/webp"] as const;
export const MESSAGE_IMAGE_MAX_COUNT = 5;
export const PORTFOLIO_IMAGE_MAX_COUNT = 20;
export const PORTFOLIO_IMAGE_MAX_SIZE_MB = 5;
